export const SEARCH_TYPE = Object.freeze({
  TERM: 1,
  ID: 2,
})
export const SEARCH_TYPE_DEFAULT = SEARCH_TYPE.TERM
export const SEARCH_TYPE_PARAM = 'searchType'
export const SEARCH_ID_PARAM = 'id'

/**
 * Validates that searchType has a valid value
 * if not returns the default one
 */
export const sanitizeStoredSearchType = (searchType) => {
  const parsedValue = parseInt(searchType, 10)
  return Object.values(SEARCH_TYPE).includes(parsedValue)
    ? parsedValue
    : SEARCH_TYPE_DEFAULT
}

/**
 * Look up on the URL params for the search type and validates it
 * if is invalid fallback to the stored type and if missing too
 * fallback to the default one
 */
export const resolveSearchType = (searchUrlParams = {}, storedType) => {
  let searchType = SEARCH_TYPE.TERM

  storedType = sanitizeStoredSearchType(storedType)
  searchType = parseInt(searchUrlParams[SEARCH_TYPE_PARAM], 10) || storedType

  return Object.values(SEARCH_TYPE).includes(searchType)
    ? searchType
    : storedType || SEARCH_TYPE_DEFAULT
}
